import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RoomTypesQueryVariables = GraphQLTypes.Exact<{ [key: string]: never; }>;


export type RoomTypesQueryResult = (
  { __typename?: 'Query' }
  & Pick<GraphQLTypes.Query, 'roomTypes'>
);


export const RoomTypesDocument = /*#__PURE__*/ gql`
    query roomTypes {
  roomTypes
}
    `;

/**
 * __useRoomTypesQuery__
 *
 * To run a query within a React component, call `useRoomTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRoomTypesQuery(baseOptions?: Apollo.QueryHookOptions<RoomTypesQueryResult, RoomTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomTypesQueryResult, RoomTypesQueryVariables>(RoomTypesDocument, options);
      }
export function useRoomTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomTypesQueryResult, RoomTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomTypesQueryResult, RoomTypesQueryVariables>(RoomTypesDocument, options);
        }
export type RoomTypesQueryHookResult = ReturnType<typeof useRoomTypesQuery>;
export type RoomTypesLazyQueryHookResult = ReturnType<typeof useRoomTypesLazyQuery>;